<template>
  <div class="bottom">
    <div class="bottom-box">
      <div class="bottom-box-left">
        <div>
          <div class="tit">关于我们</div>
          <div class="text hand" @click="skip(1)">首页</div>
          <div class="text hand" @click="skip(2)">解决方案</div>
          <div class="text hand" @click="skip(3)">联系我们</div>
        </div>
        <div class="solve">
          <div class="tit new-tit">解决方案</div>
          <div class="text text-car">路内开放式停车位解决方案</div>
          <div class="text">封闭停车场解决方案</div>
          <div class="text">半封闭停车场解决方案</div>
        </div>
      </div>
      <div class="bottom-box-right">
        <div class="logo-div">
          <img class="logoImg" src="../../assets/group.png" alt="" />
          <div>
            <div class="login-tit">科泊乐</div>
            <div class="login-english">COBBLER</div>
          </div>
        </div>
        <div class="relation">江西科泊乐智能科技有限公司</div>
        <div class="relation">电话:15228315037</div>
        <div class="relation">邮箱: client@jxcobbler.com</div>
      </div>
    </div>
    <div class="p-div">
      <p>© 2022 - 2022 江西科泊乐智能科技有限公司版权所有</p>
      <p>赣ICP备2022005749号</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods:{
    skip(idx){
      if(idx == 1){
        this.$router.push({path:'/'});
      }else if(idx == 2){
        this.$router.push({path:'/solution'});
      }else{
        this.$router.push({path:'/contact'});
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hand{
  cursor:pointer
}
.p-div {
  margin-top: 133px;
}
p {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
  line-height: 27px;
  color: #ffffff;
}
.relation {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 800;
  margin-bottom: 32px;
  font-size: 20px;
  color: #ffffff;
}
.login-english {
  font-family: "YouSheBiaoTiHei";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 26px;
  color: #ffffff;
}
.login-tit {
  font-family: "YouSheBiaoTiHei";
  font-style: normal;
  font-weight: 400;
  font-size: 46px;
  color: #ffffff;
}
.logoImg {
  width: 140px;
  margin-right: 20px;
  height: 80.45px;
}
.logo-div {
  display: flex;
  margin-bottom: 20px;
}
.text-car {
  border-top: 1px solid #ffff;
  padding-top: 16px;
}
.new-tit {
  border-bottom: 0px !important;
  margin-bottom: 0px !important;
  text-align: left;
}
.solve {
  margin-left: 38px;
  text-align: left;
}
.text {
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  text-align: left;
  margin-bottom: 8px;
  color: #ffffff;
}
.tit {
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 34px;
  color: #ffffff;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ffffff;
}
.bottom-box-left {
  display: flex;
}
.bottom-box {
  display: flex;
  padding-left: 240px;
  padding-right: 240px;
  justify-content: space-between;
}
.bottom {
  background: #081dab;
  height: 480px;
  width: 100%;
  padding-top: 70px;
  padding-bottom: 32px;
}
</style>



// WEBPACK FOOTER //
// src/view/module/bottom.vue